import { render, staticRenderFns } from "./print.vue?vue&type=template&id=5936675c&scoped=true"
import script from "./print.vue?vue&type=script&lang=js"
export * from "./print.vue?vue&type=script&lang=js"
import style0 from "./print.vue?vue&type=style&index=0&id=5936675c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5936675c",
  null
  
)

export default component.exports